import { AlertType } from "../../types/travelerProfile";

export const Clock = {
  TWELVE_HOUR: 'TWELVE_HOUR',
  TWENTY_FOUR_HOUR: 'TWENTY_FOUR_HOUR',
} as const;

const ContactPointsAPIMessageFormat = {
  HTML: 'HTML',
  MOBILE: 'MOBILE',
} as const;

export const ContactPointsMessageType = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
} as const;

export const ContactPointsAlertType = {
  PRE_TRIP: 'Pre-Trip',
  TRAVELING: 'Traveling',
  HEALTH_AND_SAFETY: 'Health & Safety',
} as const;

export const ContactPointsAPIAlertType = {
  HOME: 'HOME',
  AWAY: 'AWAY',
  HEALTH: 'HEALTH',
} as const;

export const ContactPointsToUIAlertTypeMapping = {
  [ContactPointsAPIAlertType.HOME]: ContactPointsAlertType.PRE_TRIP,
  [ContactPointsAPIAlertType.AWAY]: ContactPointsAlertType.TRAVELING,
  [ContactPointsAPIAlertType.HEALTH]: ContactPointsAlertType.HEALTH_AND_SAFETY,
} as const;

export const ContactPointsToAPIMessageFormatMapping = {
  [ContactPointsMessageType.EMAIL]: ContactPointsAPIMessageFormat.HTML,
  [ContactPointsMessageType.SMS]: ContactPointsAPIMessageFormat.MOBILE,
} as const;

export const ContactPointsToAPIAlertTypeMapping = {
  [ContactPointsAlertType.PRE_TRIP]: ContactPointsAPIAlertType.HOME,
  [ContactPointsAlertType.TRAVELING]: ContactPointsAPIAlertType.AWAY,
  [ContactPointsAlertType.HEALTH_AND_SAFETY]: ContactPointsAPIAlertType.HEALTH,
} as const;

export const ContactPointsMessageTypeOptions: {
  value: "EMAIL" | "SMS",
  label: string,
}[] = [
  { value: ContactPointsMessageType.EMAIL, label: 'Email' },
  { value: ContactPointsMessageType.SMS, label: 'SMS Message' },
];

export const contactPointFormIds = (
  alertType: AlertType,
) => ({
  messageType: `${alertType}MessageType`,
  phone: `${alertType}Phone`,
  phoneInternational: `${alertType}PhoneInternational`,
  email: `${alertType}Email`,
  sendAlerts: `${alertType}SendAlerts`,
});